<template>
    <b-modal
        id="modal-deliverynote"
        size="xl"
        ref="modal"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <b-tabs card>
                <b-tab :title="headertitle" v-bind:key="1" active>
                    <b-card-text>
                        <div>
                            <b-row>
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3">
                                            <label for="dn_reference"
                                                >{{
                                                    $t('com_reference', {
                                                        ns: 'common'
                                                    })
                                                }}:</label
                                            >
                                        </b-col>
                                        <b-col sm="9">
                                            <b-form-input
                                                id="dn_reference"
                                                :placeholder="
                                                    $t('com_reference', {
                                                        ns: 'common'
                                                    })
                                                "
                                                v-model="localItem.referentie"
                                                :disabled="!editAllowed"
                                                @change="setChanged"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col sm="3">
                                            <label for="dn_boekdate">
                                                {{
                                                    $t('prod_boekdatum', {
                                                        ns: 'production'
                                                    })
                                                }}:</label
                                            >
                                        </b-col>
                                        <b-col sm="9">
                                            <b-form-datepicker
                                                id="dn_boekdate"
                                                :date-format-options="{
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: '2-digit'
                                                }"
                                                v-model="datum"
                                                @input="setChanged"
                                                :disabled="true"
                                            ></b-form-datepicker>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="6">
                                    <b-row>
                                        <b-col sm="3">
                                            <label for="dn_location">
                                                {{
                                                    $t('com_location', {
                                                        ns: 'common'
                                                    })
                                                }}</label
                                            >
                                        </b-col>
                                        <b-col sm="9">
                                            <lookup-combo
                                                id="dn_location"
                                                v-model="localItem.locatie"
                                                v-bind:combotype="
                                                    lctypeLocation
                                                "
                                                :disabled="!editAllowed"
                                                @change="setChanged"
                                            ></lookup-combo>
                                        </b-col>
                                        <b-col sm="3">
                                            <div class="form-inline">
                                                <label
                                                    >{{
                                                        $t('com_klant', {
                                                            ns: 'common'
                                                        })
                                                    }}:</label
                                                >&nbsp; &nbsp;
                                                <b-form-checkbox
                                                    v-model="freeinput"
                                                    value="true"
                                                    unchecked-value="false"
                                                    :disabled="!editAllowed"
                                                >
                                                    <span>{{
                                                        $t('com_free', {
                                                            ns: 'common'
                                                        })
                                                    }}</span>
                                                </b-form-checkbox>
                                            </div>
                                        </b-col>
                                        <b-col sm="9" v-if="!showFreeInput">
                                            <lookup-combo
                                                v-model="localItem.klant"
                                                v-bind:combotype="lctypeCompany"
                                                :disabled="!editAllowed"
                                                @change="setChanged"
                                            ></lookup-combo>
                                        </b-col>
                                        <b-col sm="9" v-if="showFreeInput">
                                            <b-form-textarea
                                                :placeholder="
                                                    $t('prod_vrijadres', {
                                                        ns: 'production'
                                                    })
                                                "
                                                v-model="localItem.klanttekst"
                                                :disabled="!editAllowed"
                                                @change="setChanged"
                                                rows="3"
                                                no-resize
                                            ></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="1">
                                    <label for="input-itemremark"
                                        >{{
                                            $t('com_opmerking', {
                                                ns: 'common'
                                            })
                                        }}:</label
                                    >
                                </b-col>
                                <b-col sm="11">
                                    <b-form-textarea
                                        id="input-itemremark"
                                        :placeholder="
                                            $t('com_opmerking', {
                                                ns: 'common'
                                            })
                                        "
                                        v-model="localItem.opmerking"
                                        @change="setChanged"
                                        rows="3"
                                    ></b-form-textarea>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card-text>
                </b-tab>
                <special-attachments
                    v-if="localItem.id > 0"
                    :itemId="localItem.id"
                    :attType="attachmentType"
                />
            </b-tabs>
        </b-card>
        <b-card
            @submit.stop.prevent="handleSubmit"
            :header="$t('log_lines', { ns: 'logistics' })"
        >
            <div>
                <b-row>
                    <delivery-note-items
                        v-if="localItem != undefined"
                        v-bind:items="localItem.regels ?? []"
                        v-bind:geprint="!editAllowed"
                        @change="setChanged"
                    />
                </b-row>
            </div>
        </b-card>
    </b-modal>
</template>

<script lang="ts">
import { DeliveryNote, DeliveryItemStock } from '../../models/Delivery';
import { loadItem, loadList } from '../../models/DataHelper';
import DateHelper from '../../models/DateHelper';
import { LookupCombo, SpecialAttachments } from '../components';
import DeliveryNoteItems from './DeliveryNoteItems.vue';
import { defineComponent } from 'vue';
import { VueExtension } from '../../models/VueExtension';
import { AttachmentInfo } from '@/models/PlusProduction';

export default defineComponent({
    name: 'DeliveryNoteModal',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            lctypeLocation: window.constants.LCLOCATION,
            lctypeCompany: window.constants.LCCOMPANY,
            attachmentType: window.constants.ATT_DELIVERYNOTE,
            perUnitsId: 0,
            melkId: 0,
            localNaam: '',
            opmerking: '',
            vetKlasseEdit: false,

            merkaantal: 0,
            nextID: -1,
            aangeraakt_teller: 0,

            pakbon: {} as DeliveryNote,
            forcerefresh: false,
            datum: new Date(),
            freeinput: 'false'
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        inID: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        listSalesOrders: {
            type: Array,
            default: () => []
        }
    },
    components: {
        LookupCombo,
        SpecialAttachments,
        DeliveryNoteItems
    },
    watch: {},
    computed: {
        formtitle() {
            if (this.pakbon == undefined) return 'Geen selectie';
            return this.pakbon.isNew
                ? this.$t('com_makenew', {
                      ns: 'common',
                      val: this.$t('prod_pakbon', {
                          ns: 'production'
                      }).toLowerCase()
                  })
                : this.$t('com_edit', {
                      ns: 'common',
                      val: this.$t('prod_pakbon', {
                          ns: 'production'
                      }).toLowerCase()
                  });
        },
        headertitle(): string {
            const s =
                this.$t('prod_header', {
                    ns: 'production'
                }) +
                ' ' +
                this.$t('prod_pakbon', {
                    ns: 'production'
                }).toLowerCase();
            return this.pakbon.isNew ? s : s + ' #:  ' + this.pakbon.id;
        },
        localItem() {
            return this.pakbon;
        },
        showFreeInput(): boolean {
            return this.freeinput == 'true';
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                { key: 'naam', label: 'Naam', sortable: true, visible: true },
                {
                    key: 'mimetype',
                    label: 'Type',
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst: string): void {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide(): void {
            this.opmerking = '';
            this.$emit('hide');
        },
        setDeliveryNoteBase(salesOrder): void {
            if (salesOrder == undefined) return;
            this.pakbon.klantnaam = salesOrder.klantnaam;
            this.pakbon.klant = salesOrder.klantID;
            this.pakbon.referentie = salesOrder.klantRef;
            this.setChanged();
        },
        async addDeliveryNoteLine(salesOrder): Promise<void> {
            if (salesOrder == undefined) return;
            let linked = false;
            if (salesOrder.productions > 0) {
                // haal stockitem op voor de productie die gelinkt is aan de salesorder
                const tijd = DateHelper.determineVanTotUTC(null, -365, -1);
                const selectionData = {
                    from: tijd.van,
                    until: tijd.tot
                };
                const lijstAssigned = await loadItem(
                    'salesorder/loadSalesOrderBatchInfo',
                    selectionData,
                    this.$t
                );
                const sublijst = lijstAssigned.filter(
                    (x) => x.orderregelID === salesOrder.id
                );
                for (const batchItem of sublijst) {
                    const stocklist = await loadList(
                        'stock/getStockInfo',
                        'stock/loadStockInfo',
                        null,
                        false,
                        this.$t
                    );
                    // voorlopig ervan uitgaan dat we 1 stockitem hebben voor de partij
                    const stockItem = stocklist.find(
                        (x) => x.batchID === batchItem.lotnummer
                    );
                    if (stockItem != undefined) {
                        const newLine = new DeliveryItemStock();
                        this.nextID -= 1;
                        newLine.id = this.nextID;
                        newLine.aantal =
                            salesOrder.toegewezen > 0
                                ? salesOrder.toegewezen
                                : salesOrder.amount;
                        newLine.productID = stockItem.productID;
                        newLine.productnaam = salesOrder.product;
                        newLine.vorm = stockItem.vorm;
                        newLine.vormID = stockItem.vormID;
                        newLine.stockItemID = stockItem.id;
                        newLine.referentie = stockItem.batchID;
                        newLine.productiedatum =
                            stockItem.productiedatum ??
                            batchItem.productieDatum;
                        newLine.eenheidID = stockItem.unitID;

                        this.pakbon.regels.push(newLine);
                    }
                }
                linked = true;
            }
            if (salesOrder.stockitems > 0) {
                // haal stockitem op die gelinkt zijn aan de salesorder
                const lijst = await loadItem(
                    'salesorder/loadAssignedSalesOrderStockInfo',
                    {
                        productID: salesOrder.productID,
                        shapeID: salesOrder.vormID
                    },
                    this.$t
                );
                const sublijst = lijst.filter(
                    (x) => x.orderregelID === salesOrder.id
                );
                for (const stockItem of sublijst) {
                    const newLine = new DeliveryItemStock();
                    this.nextID -= 1;
                    newLine.id = this.nextID;
                    newLine.aantal =
                        stockItem.assigned ?? salesOrder.toegewezen > 0
                            ? salesOrder.toegewezen
                            : salesOrder.amount;
                    newLine.productID = salesOrder.productID;
                    newLine.productnaam = salesOrder.product;
                    newLine.vorm = salesOrder.vorm;
                    newLine.vormID = salesOrder.vormID;
                    newLine.stockItemID = stockItem.voorraadID;
                    newLine.referentie = stockItem.lotnummer;
                    newLine.productiedatum =
                        stockItem.productieDatum ?? salesOrder.productiedatum;
                    newLine.eenheidID = window.constants.STUKS; // moet uit batch of stockitem ??

                    this.pakbon.regels.push(newLine);
                }

                linked = true;
            }
            if (linked) this.setChanged();
        },
        setChanged(): void {
            this.pakbon.isChanged = true;
        },
        change(visible): void {
            this.setChanged();
            this.$emit('change', visible);
        },
        checkFormValidity(): boolean {
            const invalidBasis: string = this.pakbon.CheckValidity(this.$t);
            if (invalidBasis) this.showAlert(invalidBasis);
            const valid = this.pakbon != undefined && !invalidBasis;
            return valid;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (this.pakbon.isChanged) {
                const ok = this.checkFormValidity();
                if (!ok) {
                    return;
                }
                this.saveThisProduct();
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-deliverynote');
            });
        },
        async saveThisProduct(): Promise<void> {
            const deliveryNoteModel = this.pakbon.SetForSave();
            await loadItem(
                'delivery/addDeliveryNote',
                deliveryNoteModel,
                this.$t
            );
        }
    },
    async created() {
        if (this.inID == undefined || this.inID < 0) {
            this.pakbon = new DeliveryNote({});
            if (this.listSalesOrders.length > 0) {
                // maak voor iedere salesorder een deliverynoteline
                const firstSalesOrder = this.listSalesOrders[0] as any;
                this.setDeliveryNoteBase(firstSalesOrder);

                (this.listSalesOrders as any[]).forEach((salesOrder) => {
                    this.addDeliveryNoteLine(salesOrder);
                });
            }
        } else {
            const item = await loadItem(
                'delivery/loadDeliveryNote',
                {
                    deliverynoteID: this.inID
                },
                this.$t
            );
            this.datum = item.boektijdstip
                ? DateHelper.convertedToDateTimeJS(item.boektijdstip)
                : new Date();
            this.pakbon = item;
            this.freeinput =
                this.pakbon.klanttekst?.length > 0 ? 'true' : 'false';
        }
    }
});
</script>

<style scoped></style>

